import React from "react";
import { Container, Typography } from "@mui/material";

const About = () => {
  return (
    <Container>
      <Typography variant="h4" sx={{ mt: 4, textAlign: "center" }}>
        About App
      </Typography>
      <Typography variant="body1" sx={{ mt: 2, textAlign: "justify" }}>
        Sajjata Shravana comprises two modules namely questionnaire and conditioning for hearing test.
        Questionnaire screens for the presence and absence of hearing loss. If the child is found to have hearing loss,
        then parents/caregivers should condition their child for hearing testing. Conditioning for a hearing test trains
        the child to respond to sound. Conditioning the child for responding to the sound saves time and effort of
        clinicians and parents in the actual hearing testing.
      </Typography>
      <Typography variant="h6" sx={{ mt: 4, fontWeight: "bold", textAlign: "center" }}>
        Principal Investigator
      </Typography>
      <Typography variant="body1" sx={{ textAlign: "center", mb: 4 }}>
        Dr. Hemanth N, Professor in Audiology JSSISH.
      </Typography>
    </Container>
  );
};

export default About;